/* ==========================================================================
   Section « Candidature » — formulaire codé, envoi vers Google Sheet + Drive
   (script Apps Script).
   - pré-remplissage ?formation=<handle> : formation, ligne session
   - dépôt du CV : glisser-déposer, contrôle format + taille, puce fichier, retrait
   - validation à la soumission + bannière de résumé, re-validation au blur
   - envoi : lecture du CV en base64 -> POST JSON -> écran de confirmation + récap
   ========================================================================== */
(function () {
  'use strict';

  var MAX_CV_BYTES = 5 * 1024 * 1024;
  var CV_EXT = ['pdf', 'doc', 'docx'];

  var dataEl = document.querySelector('[data-cand-data]');
  var DATA = { default: { next: '', sessions: ['Je ne sais pas encore'], brochure: '' }, formations: {} };
  if (dataEl) {
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) {}
  }

  var form = document.getElementById('CandidatureForm');
  if (!form) return;

  var ENDPOINT = form.getAttribute('data-endpoint') || '';
  var SECRET = form.getAttribute('data-secret') || '';

  var confirmEl = document.querySelector('[data-cand-confirm]');
  var viewEl = document.querySelector('[data-cand-view]');
  var formationSelect = form.querySelector('[data-cand-formation]');
  var sessionLine = form.querySelector('[data-cand-session-line]');
  var financementSelect = form.querySelector('[data-cand-financement]');
  var submitBtn = form.querySelector('[data-cand-submit]');
  var clientAlert = form.querySelector('[data-cand-alert]');
  var clientAlertBody = form.querySelector('[data-cand-alert-body]');
  var sendError = form.querySelector('[data-cand-send-error]');

  /* ---------------------------------------------------------------- utils */
  function getParam(name) {
    try { return new URLSearchParams(window.location.search).get(name) || ''; }
    catch (e) { return ''; }
  }
  function sameOrigin(url) {
    try { return new URL(url, window.location.href).origin === window.location.origin; }
    catch (e) { return false; }
  }
  function isCoarsePointer() {
    return window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function formatSize(bytes) {
    if (bytes < 1024) return bytes + ' o';
    if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + ' Ko';
    return (bytes / (1024 * 1024)).toFixed(1).replace('.', ',') + ' Mo';
  }
  function formatDateTime(d) {
    var m = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
    var day = d.getDate() === 1 ? '1er' : d.getDate();
    return day + ' ' + m[d.getMonth()] + ' ' + d.getFullYear() + ' à ' + d.getHours() + ' h ' + pad(d.getMinutes());
  }
  function makeRef() {
    return 'AKA-' + new Date().getFullYear() + '-' + Math.floor(1000 + Math.random() * 9000);
  }
  function val(id) {
    var el = document.getElementById('CandidatureForm-' + id);
    return el ? (el.value || '') : '';
  }
  function fieldEl(key) { return form.querySelector('[data-cand-field="' + key + '"]'); }

  /* ---------------------------------------------------------------- lien retour */
  var back = document.querySelector('[data-cand-back]');
  if (back) {
    var h0 = getParam('formation');
    if (h0 && DATA.formations[h0]) back.setAttribute('href', '/pages/' + h0);
    else if (document.referrer && sameOrigin(document.referrer)) back.setAttribute('href', document.referrer);
  }

  /* ---------------------------------------------------------------- formation */
  function currentHandle() {
    if (!formationSelect) return '';
    var opt = formationSelect.options[formationSelect.selectedIndex];
    return opt ? (opt.value || '') : '';
  }
  function currentLabel() {
    if (!formationSelect) return '';
    var opt = formationSelect.options[formationSelect.selectedIndex];
    return opt ? opt.textContent.trim() : '';
  }
  function formationInfo(handle) { return (handle && DATA.formations[handle]) || DATA.default; }
  function syncFormationDependents() {
    var info = formationInfo(currentHandle());
    if (sessionLine) sessionLine.textContent = info.next || '';
  }
  if (formationSelect) {
    var initial = getParam('formation');
    if (initial && DATA.formations[initial]) formationSelect.value = initial;
    formationSelect.addEventListener('change', function () {
      clearError(fieldEl('formation'));
      syncFormationDependents();
    });
    syncFormationDependents();
  }

  /* ---------------------------------------------------------------- CV drop */
  var fileInput = form.querySelector('[data-cand-file]');
  var dropZone = form.querySelector('[data-cand-drop]');
  var chip = form.querySelector('[data-cand-file-chip]');
  var chipName = form.querySelector('[data-cand-file-name]');
  var chipSize = form.querySelector('[data-cand-file-size]');
  var chipRemove = form.querySelector('[data-cand-file-remove]');
  var dropLead = form.querySelector('[data-cand-drop-lead]');
  var dropBrowse = dropZone && dropZone.querySelector('.cand-drop__browse');

  if (isCoarsePointer() && dropLead && dropBrowse) {
    dropLead.textContent = 'Touchez pour ';
    dropBrowse.textContent = 'choisir un fichier';
  }

  function fileError(file) {
    if (!file) return 'Le CV est obligatoire pour étudier votre candidature.';
    var ext = (file.name.split('.').pop() || '').toLowerCase();
    if (CV_EXT.indexOf(ext) === -1) return 'Format non accepté (PDF, DOC, DOCX).';
    if (file.size > MAX_CV_BYTES) return 'Fichier trop lourd (5 Mo maximum).';
    return '';
  }
  function showChip(file) {
    if (!chip) return;
    chipName.textContent = file.name;
    chipSize.textContent = formatSize(file.size) + ' · ' + (file.name.split('.').pop() || '').toUpperCase();
    chip.hidden = false;
    if (dropZone) dropZone.hidden = true;
  }
  function resetChip() {
    if (chip) chip.hidden = true;
    if (dropZone) { dropZone.hidden = false; dropZone.classList.remove('is-dragover'); }
    if (fileInput) fileInput.value = '';
  }
  function handleFiles(files) {
    if (!files || !files.length) return;
    var file = files[0];
    var err = fileError(file);
    if (err) { resetChip(); setError(fieldEl('cv'), err); return; }
    try {
      var dt = new DataTransfer();
      dt.items.add(file);
      fileInput.files = dt.files;
    } catch (e) {}
    clearError(fieldEl('cv'));
    showChip(file);
  }
  if (dropZone && fileInput) {
    dropZone.addEventListener('click', function () { fileInput.click(); });
    dropZone.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); }
    });
    ['dragenter', 'dragover'].forEach(function (ev) {
      dropZone.addEventListener(ev, function (e) { e.preventDefault(); dropZone.classList.add('is-dragover'); });
    });
    ['dragleave', 'dragend', 'drop'].forEach(function (ev) {
      dropZone.addEventListener(ev, function () { dropZone.classList.remove('is-dragover'); });
    });
    dropZone.addEventListener('drop', function (e) { e.preventDefault(); handleFiles(e.dataTransfer && e.dataTransfer.files); });
    fileInput.addEventListener('change', function () { handleFiles(fileInput.files); });
  }
  if (chipRemove) {
    chipRemove.addEventListener('click', function () { resetChip(); clearError(fieldEl('cv')); });
  }

  /* ---------------------------------------------------------------- validation */
  function setError(wrap, message) {
    if (!wrap) return;
    wrap.classList.add('is-error');
    var box = wrap.querySelector('[data-cand-error]');
    var txt = wrap.querySelector('[data-cand-error-text]');
    if (box && txt) { txt.textContent = message; box.hidden = false; if (!box.id) box.id = wrap.getAttribute('data-cand-field') + '-cand-error'; }
    var input = wrap.querySelector('.cand-input, .cand-file-input');
    if (input && box) { input.setAttribute('aria-invalid', 'true'); input.setAttribute('aria-describedby', box.id); }
  }
  function clearError(wrap) {
    if (!wrap) return;
    wrap.classList.remove('is-error');
    var box = wrap.querySelector('[data-cand-error]');
    if (box) box.hidden = true;
    var input = wrap.querySelector('.cand-input, .cand-file-input');
    if (input) { input.removeAttribute('aria-invalid'); input.removeAttribute('aria-describedby'); }
  }

  var RULES = [
    { key: 'formation', label: 'Formation concernée', anchor: 'CandidatureForm-formation',
      test: function () { return !!currentHandle(); }, message: 'Choisissez la formation visée.' },
    { key: 'prenom', label: 'Prénom', anchor: 'CandidatureForm-prenom',
      test: function () { return val('prenom').trim().length >= 2; }, message: 'Ce champ est obligatoire.' },
    { key: 'nom', label: 'Nom', anchor: 'CandidatureForm-nom',
      test: function () { return val('nom').trim().length >= 2; }, message: 'Ce champ est obligatoire.' },
    { key: 'email', label: 'E-mail', anchor: 'CandidatureForm-email',
      test: function () { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val('email')); }, message: 'Cette adresse e-mail est incomplète.' },
    { key: 'telephone', label: 'Téléphone', anchor: 'CandidatureForm-telephone',
      test: function () { return val('telephone').replace(/\D/g, '').length >= 9; }, message: 'Numéro de téléphone invalide.' },
    { key: 'cv', label: 'CV', anchor: 'CandidatureForm-cv',
      test: function () { var f = fileInput && fileInput.files && fileInput.files[0]; return !!f && !fileError(f); }, message: null },
    { key: 'motivation', label: 'Présentation & motivation', anchor: 'CandidatureForm-motivation',
      test: function () { return val('motivation').trim().length >= 40; }, message: 'Présentez-vous en quelques lignes.' },
    { key: 'linkedin', label: 'Profil LinkedIn', anchor: 'CandidatureForm-linkedin', optional: true,
      test: function () { var s = val('linkedin').trim(); return !s || /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/\S*)?$/.test(s); }, message: 'URL invalide.' },
    { key: 'rgpd', label: 'Consentement', anchor: 'CandidatureForm-rgpd',
      test: function () { var c = document.getElementById('CandidatureForm-rgpd'); return !!(c && c.checked); }, message: 'Votre accord est nécessaire pour traiter la demande.' }
  ];

  function ruleMessage(rule) {
    if (rule.key === 'cv') return fileError(fileInput && fileInput.files && fileInput.files[0]);
    return rule.message;
  }
  function validate() {
    var failed = [];
    RULES.forEach(function (rule) {
      var wrap = fieldEl(rule.key);
      if (rule.test()) clearError(wrap);
      else { setError(wrap, ruleMessage(rule)); failed.push(rule); }
    });
    return failed;
  }
  function renderSummary(failed) {
    if (!clientAlert || !clientAlertBody) return;
    if (!failed.length) { clientAlert.hidden = true; return; }
    var n = failed.length;
    clientAlertBody.innerHTML = '';
    clientAlertBody.appendChild(document.createTextNode('Merci de corriger ' + n + (n > 1 ? ' champs' : ' champ') + ' avant d’envoyer votre candidature : '));
    failed.forEach(function (rule, i) {
      var a = document.createElement('a');
      a.href = '#' + rule.anchor;
      a.textContent = rule.label;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(rule.anchor);
        var dz = rule.key === 'cv' ? form.querySelector('[data-cand-drop]') : null;
        var focusEl = (dz && !dz.hidden) ? dz : target;
        if (focusEl) { focusEl.scrollIntoView({ block: 'center', behavior: 'smooth' }); focusEl.focus({ preventScroll: true }); }
      });
      clientAlertBody.appendChild(a);
      clientAlertBody.appendChild(document.createTextNode(i < n - 1 ? ', ' : '.'));
    });
    clientAlert.hidden = false;
  }
  RULES.forEach(function (rule) {
    var wrap = fieldEl(rule.key);
    if (!wrap) return;
    var el = wrap.querySelector('.cand-input') || document.getElementById(rule.anchor);
    if (!el) return;
    el.addEventListener('blur', function () {
      if (!wrap.classList.contains('is-error')) return;
      if (rule.test()) clearError(wrap);
      else setError(wrap, ruleMessage(rule));
    });
  });

  /* ---------------------------------------------------------------- envoi */
  function readFileAsDataURL(file) {
    return new Promise(function (resolve, reject) {
      var r = new FileReader();
      r.onload = function () { resolve(r.result); };
      r.onerror = function () { reject(r.error || new Error('read error')); };
      r.readAsDataURL(file);
    });
  }

  function setRow(key, value) {
    var row = confirmEl.querySelector('[data-cand-recap-row="' + key + '"]');
    if (!row) return;
    if (!value) { row.hidden = true; return; }
    var v = row.querySelector('[data-cand-recap-value]');
    if (v) v.textContent = value;
  }

  function showConfirmation(payload, cvUrl) {
    if (!confirmEl) { return; }
    var fn = confirmEl.querySelector('[data-cand-firstname]');
    if (fn && payload.prenom) fn.textContent = ' ' + payload.prenom;
    var emWrap = confirmEl.querySelector('[data-cand-email-wrap]');
    var em = confirmEl.querySelector('[data-cand-email]');
    if (emWrap && em && payload.email) { em.textContent = payload.email; emWrap.hidden = false; }

    var recap = confirmEl.querySelector('[data-cand-recap]');
    if (recap) {
      setRow('formation', payload.formation);
      setRow('session', payload.session);
      setRow('financement', payload.financement);
      setRow('cv', cvUrl ? payload.cvName + ' — ' + cvUrl : payload.cvName);
      setRow('date', formatDateTime(new Date(payload.submittedAt)));
      var refEl = confirmEl.querySelector('[data-cand-ref]');
      if (refEl) refEl.textContent = payload.ref;
      recap.hidden = false;
    }

    if (viewEl) viewEl.hidden = true;
    confirmEl.hidden = false;
    try { window.scrollTo(0, 0); } catch (e) {}
  }

  function setBusy(on) {
    if (!submitBtn) return;
    if (on) { submitBtn.setAttribute('aria-busy', 'true'); submitBtn.textContent = 'Envoi…'; }
    else { submitBtn.removeAttribute('aria-busy'); submitBtn.textContent = 'Envoyer ma candidature'; }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (sendError) sendError.hidden = true;

    var failed = validate();
    renderSummary(failed);
    if (failed.length) {
      if (clientAlert) { clientAlert.focus(); clientAlert.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      return;
    }
    if (!ENDPOINT) { if (sendError) sendError.hidden = false; return; }

    setBusy(true);
    var file = fileInput.files[0];

    readFileAsDataURL(file).then(function (dataUrl) {
      var payload = {
        secret: SECRET,
        website: val('website'),
        ref: makeRef(),
        submittedAt: new Date().toISOString(),
        formation: currentLabel(),
        formationHandle: currentHandle(),
        prenom: val('prenom').trim(),
        nom: val('nom').trim(),
        email: val('email').trim(),
        telephone: val('telephone').trim(),
        entreprise: val('entreprise').trim(),
        fonction: val('fonction').trim(),
        financement: financementSelect ? financementSelect.value : '',
        session: val('session').trim(),
        linkedin: val('linkedin').trim(),
        source: val('source'),
        motivation: val('motivation').trim(),
        rgpd: document.getElementById('CandidatureForm-rgpd').checked ? 'Oui' : 'Non',
        cvName: file.name,
        cvType: file.type || '',
        cvSize: file.size,
        cvData: dataUrl
      };

      return fetch(ENDPOINT, { method: 'POST', body: JSON.stringify(payload), redirect: 'follow' })
        .then(function (res) {
          return res.json().then(function (json) { return { json: json }; }, function () { return { json: null }; });
        })
        .then(function (r) {
          if (r.json && r.json.ok === false) { throw new Error(r.json.error || 'refus du script'); }
          showConfirmation(payload, r.json && r.json.cvUrl ? r.json.cvUrl : '');
        });
    }).catch(function (err) {
      setBusy(false);
      if (sendError) { sendError.hidden = false; sendError.focus(); sendError.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      if (window.console) console.warn('[candidature] envoi échoué :', err);
    });
  });
})();
